import mapSignals from '../data/map-sinais.json';

class SignalService {
  getSignals() {
    return mapSignals;
  }

  getSignalById(signalId: string) {
    for (const pack of mapSignals) {
      const itemFinded = pack.find(item => item.id === signalId)

      if (itemFinded) {
        return itemFinded;
      }
    }
  }
}

export default new SignalService();
